<template>
    <div class="terms-conditions">
        <div class="container">
            <h3>TERMS AND CONDITIONS</h3>
            <p>
                *18+ only. Following purchase, product must be installed on system where coupon code will be redeemed.
                Void where prohibited. Residency and additional limitations apply. Full offer terms at
                www.amdrewards.com/terms.
            </p>
            <p>
                Game Pass for PC Offer: Participating retailers only for eligible purchases made July 1, 2019 through
                March 10, 2020 or when supply of coupon codes is exhausted. Over 100 PC Games available starting August
                2019. Gears 5 available fall 2019. Game Pass code must be redeemed by June 30, 2020.
            </p>
            <p>
                Limit one promotional 3-month subscription per Microsoft account over a 12-month period. Requires the
                Xbox (beta) app and Windows 10 (with updates). Age restrictions and system requirements apply. Game
                catalog varies over time. Learn more at Xbox.com/gamepass.
            </p>
            <p>
                Up to 2 Games Offer: Participating retailers only for eligible purchases made September 30, 2019 through
                December 31, 2019 or when supply of coupon codes is exhausted. Coupon code must be redeemed by January
                30, 2020.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TermsConditions'
    }
</script>

<style lang="scss" scoped>

    .terms-conditions {
        margin-left: -15px;
        margin-right: -15px;
        background-color: #464B55;
        padding: 60px 0px;

        h3 {
            color: #9B9B9B;
            font-size: 18px;
            line-height: 22px;
            padding-bottom: 16px;
            text-align: center;

            @media screen and (max-width: 640px) and (min-width: 320px){
                text-align: left;
            }

        }

        p {
            color: #9B9B9B;
            font-size: 14px;
            line-height: 17px;
            text-align: center;

            @media screen and (max-width: 640px) and (min-width: 320px){
                text-align: left;
            }

        }

    }

</style>